import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asDetailTab, type DetailTabId } from '@/features/ai/ai-href';
import { BudgetDetailPage } from '@/features/ai/llm/llm-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Budget de jetons d’un projet et consommation de sa fenêtre. */
export const Route = createFileRoute('/$tenant/llm/budgets/$projectId')({
  validateSearch: (search: Record<string, unknown>): { tab: DetailTabId } => ({
    tab: asDetailTab(search['tab']),
  }),
  component: BudgetDetailRoute,
});

function BudgetDetailRoute() {
  const { tenant, projectId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="llmGateway"
      crumbs={[
        { label: t('nav.items.llmGateway') },
        { label: <EntityName tenantId={tenant} kind="project" id={projectId} /> },
      ]}
    >
      <BudgetDetailPage
        tenantId={tenant}
        projectId={projectId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
